// test1194
(1194 && 0);
